module.exports = __webpack_public_path__ + "img/collapse.d31d5c7b.svg";